export default __webpack_public_path__ + "static/media/36.680baa54.png";